<template>
  <div class="new-table-temp">
    <div class="bg-white">
      <el-table :data="tableData" stripe @sort-change="sortChange" style="width: 100%" :height="height" header-cell-class-name="table-header-cell" header-row-class-name="table-header-row" id="tabletemp">
        <el-table-column v-for="(item, index) in tableHead" :min-width="tableHead[index] && tableHead[index].width ? tableHead[index].width : ''" :align="tableHead[index] && tableHead[index].align ? tableHead[index].align : 'left'" :key="index" :prop="tableHead[index].tag ? tableHead[index].tag : tdTextFn(index)" :sortable="tableHead[index] && tableHead[index].sort ? true : false" :label="tableHead[index].title" :fixed="tableHead[index] && tableHead[index].fixed ? true : false">
          <template slot-scope="scope">
            <!--A标签-->
            <div v-if="tableHead[index] && tableHead[index].link" :style="tableHead[index] && tableHead[index].color ? 'color:' + tableHead[index].color : ''">
              <a :href="tableHead[index].link" v-html="tableHead[index].tag ? scope.row[tableHead[index].tag] : scope.row[tdTextFn(index)]"></a>
            </div>
            <!--秒-->
            <div v-else-if="tableHead[index] && tableHead[index].seconds" :style="tableHead[index] && tableHead[index].color ? 'color:' + tableHead[index].color : ''">
              <!--如果有指定参数tag 则按指定参数取数据（可以在tableHead里通过设置tag参数指定th排列顺序）-->
              {{tableHead[index].tag ? (String(scope.row[tableHead[index].tag]) === 'undefined' ? '-' : util.formatSeconds(scope.row[tableHead[index].tag] || 0)) : '—'}}
            </div>
            <!--百分比-->
            <div v-else-if="tableHead[index] && tableHead[index].percent" :style="tableHead[index] && tableHead[index].color ? 'color:' + tableHead[index].color : ''">
              <!--如果有指定参数tag 则按指定参数取数据（可以在tableHead里通过设置tag参数指定th排列顺序）-->
              <!-- {{tableHead[index].tag ? (scope.row[tableHead[index].tag] || '0') + '%' : scope.row[tdTextFn(index)] + '%'}} -->
              {{tableHead[index].tag ? (Number(scope.row[tableHead[index].tag]) > -1 ? (scope.row[tableHead[index].tag] || '0') + '%' : scope.row[tableHead[index].tag] || '-') : scope.row[tdTextFn(index)] + '%'}}
            </div>
            <!--进度条-->
            <div v-else-if="tableHead[index] && tableHead[index].percentLine" class="perBox" :style="tableHead[index] && tableHead[index].color ? 'color:' + tableHead[index].color : ''">
              <div class="lineBlock" :style="{width: tableHead[index].tag ? scope.row[tableHead[index].tag] + '%' : scope.row[tdTextFn(index)] + '%'}"></div><span class="lineNum" :style="{left: tableHead[index].tag ? scope.row[tableHead[index].tag] + 5 + '%' : scope.row[tdTextFn(index)] + 5 + '%'}">{{tableHead[index].tag ? scope.row[tableHead[index].tag] + '%' : scope.row[tdTextFn(index)] + '%'}}</span>
            </div>
            <!--千分位-->
            <div v-else-if="tableHead[index] && tableHead[index].thousand" :style="tableHead[index] && tableHead[index].color ? 'color:' + tableHead[index].color : ''">
              {{tableHead[index].tag ? (String(scope.row[tableHead[index].tag]) === 'undefined' && tableHead[index].tag !== 'no' ? '-' : util.numberFormat(scope.row[tableHead[index].tag])) : util.numberFormat(scope.row[tdTextFn(index)])}}
            </div>
            <!--普通数据补0-->
            <div class="oneline" v-else-if="tableHead[index] && tableHead[index].zero" :style="tableHead[index] && tableHead[index].color ? 'color:' + tableHead[index].color : ''">
              {{tableHead[index].tag ? (scope.row[tableHead[index].tag] ? scope.row[tableHead[index].tag] : '0') : scope.row[tdTextFn(index)]}}
            </div>
            <!--普通数据-->
            <div :class="tableHead[index] && tableHead[index].oneline ? 'oneline' : ''" v-else :style="tableHead[index] && tableHead[index].color ? 'color:' + tableHead[index].color : ''">
              {{tableHead[index].tag ? (String(scope.row[tableHead[index].tag]) === 'undefined' && tableHead[index].tag !== 'no' ? '-' : scope.row[tableHead[index].tag]) : scope.row[tdTextFn(index)]}}
              <!-- {{tableHead[index].tag ? scope.row[tableHead[index].tag] : scope.row[tdTextFn(index)]}} -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TableTempNew',
  props: [
    'tableData',
    'tableHead',
    'height',
    'customSort'
  ],
  data () {
    return {
      keys: []
    }
  },
  methods: {
    sortChange (params) {
      this.customSort && this.$emit('tableSortChange', params)
    },
    tdTextFn (index) {
      return this.keys[index]
    }
  },
  watch: {
    tableData (val) {
      if (this.tableData && this.tableData.length > 0) {
        for (var key in this.tableData[0]) {
          this.keys.push(key)
        }
      }
    }
  },
  mounted () {
  }
}
</script>
<style>
.table-header-cell{
  border-bottom: 2px solid #f5f5f5!important;
  color: #808080!important;
  font-size: 12px!important;
  text-align: left!important;
}

#tabletemp .table-header-cell, #tabletemp .table-header-cell:nth-of-type(2) {
  text-align: left!important;
}
.cell{
  color: #808080;
}

.lineBlock{
  width: auto;
  height: 20px;
  background: #20ACEE;
  float: left;
}
.perBox{
  position: relative;
  margin-right: 50px;
}
.lineNum{
  position: absolute;
  top: 0;
  word-break: normal;
}
.item{
  font-size: 14px;
  color: #666;
}
.oneline {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
